/*
	Montos sin «.00» cuando no hay centavos (Esteban, 2026-11-02: «¿por qué usamos centavos donde no se usan?»; en 2026 solo
	218 de 65,559 pagos llevaron centavos). Con centavos se enseñan los dos decimales. Siempre con coma de miles.
	Acepta un número o el moneyFormat que manda el servidor («L1500.00», «$-250.50»).
*/
export const dineroCorto = (v: number | string | null | undefined, simbolo: string = ""): string => {
	let n: number;
	let s = simbolo;
	if (typeof v === "string") {
		const m = v.trim().match(/^([^\d-]*)(-?[\d,]*\.?\d*)\s*$/);
		if (!m || !/\d/.test(m[2])) return v;
		s = s || m[1];
		n = Number(m[2].replace(/,/g, ""));
		if (!isFinite(n)) return v;
	} else {
		n = Number(v || 0);
	}
	// Un número roto se enseña como «—», nunca como un $0 que lo esconda.
	if (!isFinite(n)) return s + "—";
	let r = Math.round(n * 100) / 100;
	if (Math.abs(r) < 0.005) r = 0;   // sin «-0»
	const conCentavos = Math.abs(r - Math.round(r)) > 0.004;
	return s + r.toLocaleString("es-MX", { minimumFractionDigits: conCentavos ? 2 : 0, maximumFractionDigits: 2 });
};

export default dineroCorto;
